/**
 * Calculadora de entrega (Optioutlet).
 *
 * Tres días hábiles a cualquier parte del país. El cálculo corre en el
 * navegador y no en Liquid a propósito: así "hoy" es el día del visitante
 * y no el del servidor, y la respuesta no se queda congelada si Shopify
 * cachea la página.
 *
 * El calendario es propio. El <input type="date"> nativo se pinta blanco
 * y azul, no se puede maquetar, y solo abre si le atinas al iconito.
 */
const DIAS_HABILES = 3;
const MESES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

const bloque = document.querySelector('[data-ol-entrega]');
if (bloque) {
  const veredicto = bloque.querySelector('[data-ol-veredicto]');
  const detalle = bloque.querySelector('[data-ol-detalle]');
  const boton = bloque.querySelector('[data-ol-abrir]');
  const valor = bloque.querySelector('[data-ol-valor]');
  const panel = bloque.querySelector('[data-ol-cal]');
  const rejilla = bloque.querySelector('[data-ol-dias]');
  const nombreMes = bloque.querySelector('[data-ol-mes-nombre]');

  const aMedianoche = (f) => new Date(f.getFullYear(), f.getMonth(), f.getDate());
  const esHabil = (f) => f.getDay() !== 0 && f.getDay() !== 6;
  const enDias = (a, b) => Math.round((aMedianoche(a) - aMedianoche(b)) / 86400000);

  function sumarHabiles(desde, dias) {
    const f = new Date(desde.getTime());
    let faltan = dias;
    while (faltan > 0) {
      f.setDate(f.getDate() + 1);
      if (esHabil(f)) faltan -= 1;
    }
    return f;
  }

  function restarHabiles(hasta, dias) {
    const f = new Date(hasta.getTime());
    let faltan = dias;
    while (faltan > 0) {
      f.setDate(f.getDate() - 1);
      if (esHabil(f)) faltan -= 1;
    }
    return f;
  }

  /** "miércoles 7 de octubre", sin la coma que mete toLocaleDateString. */
  const fecha = (f) =>
    `${f.toLocaleDateString('es-MX', { weekday: 'long' })} ${f.getDate()} de ${MESES[f.getMonth()]}`;

  const hoy = aMedianoche(new Date());
  const llegadaSiPidesHoy = sumarHabiles(hoy, DIAS_HABILES);

  let elegida = null;
  let mesVisible = new Date(hoy.getFullYear(), hoy.getMonth(), 1);

  // ------------------------------------------------------------ respuesta

  function pintar(estado, titulo, texto) {
    bloque.dataset.estado = estado;
    veredicto.textContent = titulo;
    detalle.innerHTML = texto;
  }

  function responder() {
    if (!elegida) {
      valor.textContent = 'Elige el día';
      valor.dataset.vacio = 'true';
      return pintar(
        'neutro',
        `Si lo pides hoy, llega el ${fecha(llegadaSiPidesHoy)}.`,
        'Dinos qué día es tu fiesta y te decimos si lo alcanzas.'
      );
    }

    valor.textContent = fecha(elegida).replace(/^./, (c) => c.toUpperCase());
    valor.dataset.vacio = 'false';

    const margen = enDias(elegida, llegadaSiPidesHoy);

    if (margen < 0) {
      return pintar(
        'malo',
        'Pidiendo hoy no alcanza.',
        `Llegaría el ${fecha(llegadaSiPidesHoy)}, y tu fiesta es el ${fecha(elegida)}. ` +
          'Escríbenos al <a href="tel:+525514949426">55 1494 9426</a> y vemos qué se puede hacer.'
      );
    }

    const limite = restarHabiles(elegida, DIAS_HABILES);
    const cola = enDias(limite, hoy) <= 0
      ? 'Pídelo hoy mismo y llega a tiempo.'
      : `Pídelo a más tardar el ${fecha(limite)} y llega a tiempo.`;

    if (margen === 0) return pintar('justo', 'Llega el mismo día de tu fiesta.', `Va muy justo. ${cola}`);
    if (margen === 1) return pintar('bueno', 'Llega un día antes.', cola);
    return pintar('bueno', `Sí llega, con ${margen} días de sobra.`, cola);
  }

  // ----------------------------------------------------------- calendario

  function pintarMes() {
    nombreMes.textContent = `${MESES[mesVisible.getMonth()]} ${mesVisible.getFullYear()}`;

    // No se puede retroceder antes del mes en curso: no hay nada que elegir.
    const atras = bloque.querySelector('[data-ol-mes="-1"]');
    atras.disabled = mesVisible.getFullYear() === hoy.getFullYear() && mesVisible.getMonth() === hoy.getMonth();

    rejilla.textContent = '';

    // La semana arranca en lunes, como en México; getDay() arranca en domingo.
    const primero = new Date(mesVisible.getFullYear(), mesVisible.getMonth(), 1);
    const hueco = (primero.getDay() + 6) % 7;
    for (let i = 0; i < hueco; i += 1) {
      const v = document.createElement('span');
      v.className = 'ol-cal__vacio';
      rejilla.append(v);
    }

    const ultimo = new Date(mesVisible.getFullYear(), mesVisible.getMonth() + 1, 0).getDate();
    for (let d = 1; d <= ultimo; d += 1) {
      const dia = new Date(mesVisible.getFullYear(), mesVisible.getMonth(), d);
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ol-cal__dia';
      b.textContent = String(d);
      b.setAttribute('aria-label', fecha(dia));

      if (enDias(dia, hoy) < 0) b.disabled = true;
      if (enDias(dia, hoy) === 0) b.classList.add('ol-cal__dia--hoy');
      if (enDias(dia, llegadaSiPidesHoy) < 0) b.classList.add('ol-cal__dia--tarde');
      if (elegida && enDias(dia, elegida) === 0) {
        b.classList.add('ol-cal__dia--elegido');
        b.setAttribute('aria-current', 'date');
      }

      b.addEventListener('click', () => {
        elegida = dia;
        responder();
        pintarMes();
        cerrar();
      });

      rejilla.append(b);
    }
  }

  /**
   * Decide si el panel abre hacia abajo o hacia arriba.
   *
   * Desde que la calculadora vive en el pie, "hacia abajo" casi nunca
   * cabe: debajo del campo ya no queda página. Se mide en vez de atarlo
   * al pie porque lo mismo pasa en una pantalla baja aunque la sección
   * esté a media altura.
   *
   * Si no cabe de ningún lado se va al que tenga más aire, que es lo
   * menos malo: al menos se ve la mitad de arriba del calendario.
   */
  function acomodar() {
    panel.classList.remove('ol-cal--arriba');
    const campo = boton.getBoundingClientRect();
    const alto = panel.offsetHeight;
    const abajo = window.innerHeight - campo.bottom;
    if (abajo < alto + 8 && campo.top > abajo) panel.classList.add('ol-cal--arriba');
  }

  function abrir() {
    if (elegida) mesVisible = new Date(elegida.getFullYear(), elegida.getMonth(), 1);
    pintarMes();
    panel.hidden = false;
    // Después de pintarlo y de quitarle el hidden: antes no mide nada.
    acomodar();
    boton.setAttribute('aria-expanded', 'true');
    // El foco entra al día elegido, o al primero que sí alcanza.
    (panel.querySelector('.ol-cal__dia--elegido') ||
      panel.querySelector('.ol-cal__dia:not(:disabled)'))?.focus();
  }

  function cerrar({ devolverFoco = true } = {}) {
    if (panel.hidden) return;
    panel.hidden = true;
    boton.setAttribute('aria-expanded', 'false');
    if (devolverFoco) boton.focus();
  }

  boton.addEventListener('click', () => (panel.hidden ? abrir() : cerrar()));

  for (const paso of bloque.querySelectorAll('[data-ol-mes]')) {
    paso.addEventListener('click', () => {
      mesVisible = new Date(mesVisible.getFullYear(), mesVisible.getMonth() + Number(paso.dataset.olMes), 1);
      pintarMes();
      // Un mes puede ocupar cinco renglones de semana y el siguiente seis:
      // abierto hacia arriba, ese renglón de más lo empuja fuera de la
      // pantalla si no se vuelve a medir.
      acomodar();
    });
  }

  panel.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.stopPropagation(); cerrar(); }
  });

  document.addEventListener('click', (e) => {
    if (!panel.hidden && !bloque.querySelector('[data-ol-fecha]').contains(e.target)) cerrar({ devolverFoco: false });
  });

  responder();

  /* El aviso para lectores de pantalla se enciende aquí, ya pintada la
     primera respuesta. Puesto en el marcado, el lector cantaba el
     veredicto de arranque en cada carga, y desde que esto vive en el pie
     eso sería en todas las páginas. Lo que vale la pena oír es lo que
     cambia al elegir día. */
  bloque.querySelector('[data-ol-respuesta]')?.setAttribute('aria-live', 'polite');
}
